import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lib-ngx-live-view',
  template: ` <p>ngx-live-view works!</p> `,
  styles: [],
})
export class NgxLiveViewComponent {
  constructor() {}
}
